// src/pages/Login.jsx

import React from "react";

import camion from "../images/camion-danlu.png";
import LoginForm from "../components/LoginForm";
import Footer from "../components/Footer";

import "../css/login.css";

import logo from "../images/DANLU_logo_transparent.png";

const Login = () => {
  return (
    <>
      <main className="danlu-login-page">

        {/* =====================================================
            PANEL IZQUIERDO
        ===================================================== */}

        <section className="danlu-login-hero">

          <div className="danlu-login-hero-content">

            <div className="danlu-login-kicker">
              Transporte Danlu
            </div>

            <h1>
              Gestión logística y operativa
              en una sola plataforma.
            </h1>

            <p>
              Viajes, rendiciones, cajas,
              movimientos, peajes, seguros
              y control administrativo
              centralizados en un único sistema.
            </p>

            <div className="danlu-login-badges">
              <span>Viajes</span>
              <span>Finanzas</span>
              <span>Logística</span>
            </div>

          </div>

          {/* CAMIÓN ANIMADO */}

          <div
            className="danlu-truck-stage"
            aria-hidden="true"
          >
            <img  src={camion} alt="" className="danlu-truck-image" />

            <div className="danlu-truck-shadow" />
          </div>

          {/* LOGO MARCA DE AGUA */}

          <img
            src={logo}
            alt=""
            className="danlu-login-watermark"
            aria-hidden="true"
          />

        </section>


        {/* =====================================================
            PANEL LOGIN
        ===================================================== */}

        <section className="danlu-login-panel">

          <div className="danlu-login-card">

            <div className="danlu-login-brand">

              <img
                src={logo}
                alt="Transporte Danlu"
              />

              <div>
                <h2>
                  Ingresar a Transporte Danlu
                </h2>

                <p>
                  Sistema de Gestión
                </p>
              </div>

            </div>

            <LoginForm />

            <div className="danlu-login-note">
              Acceso seguro al panel operativo.
            </div>

          </div>

        </section>

      </main>

      <Footer />
    </>
  );
};

export default Login;